import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import * as actionTypes from '../../redux/actions/seniormaster/actionTypes';
import { updateCommission } from '../../redux/actions/seniormaster/updateSeniormaster';

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 24 },
};

class UpdateSMCommissionModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate({
            id:this.props.smaster?.id,
            commissionId:this.props.commission?.id,
            matchCount:values.matchCount,
            betCommission:values.betCommission,
            winCommission:values.winCommission
        },
            this.props.token);
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Commission"
                key={this.props.commission?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-c-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                {...layout}
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-c-form"
                    name="basic"
                    initialValues={{
                        matchCount:this.props.commission?.matchCount,
                        betCommission:this.props.commission?.betCommission,
                        winCommission:this.props.commission?.winCommission
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    
                    <Form.Item
                        name="matchCount"
                        label="Match Count"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    <Form.Item
                        name="winCommission"
                        label="Tax"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    <Form.Item
                        name="betCommission"
                        label="Commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.seniorMaster.updateCommissionVisible,
    loading: state.seniorMaster.loading,
    token: state.auth.token,
    error: state.seniorMaster.error,
    message: state.seniorMaster.message,
    smaster:state.seniorMaster.one,
    commission:state.seniorMaster.commissionToUpdate
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (obj, token) => dispatch(updateCommission(obj, token)),
    onClose: () => dispatch({
        type:actionTypes.TOGGLE_COMMISSION_UPDATE
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSMCommissionModal);